import type { RootStore } from '../../types/global-store';

export const selectLoggedInAccount = (state: RootStore) => state.account;
